/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import GlobalPortal from "./GlobalPortal.jsx";
import {AnimatePresence, motion} from "motion/react";
import CloseButton from "./CloseButton.jsx";
import DialogButton from "./UIGeneratorComponents/DialogButton.jsx";


const InlineDialog = ({isOpen, title, width = "max-w-md", children, button = [], onClose}) => {
    return (
        <GlobalPortal>
            <div className={"fixed inset-0 overflow-hidden pointer-events-none z-30"}>
                <div className={"absolute inset-0 overflow-hidden z-30"}>
                    <AnimatePresence>

                        {/* Background Overlay */}
                        {(isOpen) && (
                            <motion.div
                                initial={{opacity: 0}}
                                animate={{opacity: 0.6}}
                                exit={{opacity: 0}}
                                className={`absolute inset-0 bg-stone-500 opacity-40 w-full h-full pointer-events-none`}
                            />
                        )}

                        {/* The Actual Panel */}
                        {isOpen && (
                            <motion.div
                                initial={{y: 50, opacity: 0}}
                                animate={{
                                    y: 0,
                                    opacity: 1,
                                    zIndex: 10,
                                }}
                                exit={{
                                    y: 50,
                                    opacity: 0,
                                    zIndex: 10,
                                }}
                                transition={{type: "spring", stiffness: 200, damping: 20, duration: 0.4}}
                                className={`absolute inset-0 flex items-center justify-center p-4 pointer-events-none`}
                            >
                                <div
                                    className={"w-full " + width + " pointer-events-auto"}>

                                    <div
                                        className="flex flex-col bg-white shadow-xl rounded-lg max-h-[90vh]">

                                        <div className="pl-4  h-14 shrink-0 flex items-center justify-between">
                                            <h2
                                                className="text-base font-semibold text-gray-900 truncate">
                                                {title}
                                            </h2>
                                            <CloseButton clickZoneClassname={"pl-3 pr-3"} onClick={() => {
                                                // this is a bigger target for the close button to make it easy to hit
                                                if (onClose !== undefined) {
                                                    onClose()
                                                }
                                            }}/>
                                        </div>

                                        <div
                                            className="relative flex-1 px-4 pt-3 pb-10 overflow-y-auto customScrollbar focus:outline-hidden"
                                            tabIndex={-1}>
                                            {/* content */}
                                            {children}
                                        </div>


                                        <DialogButton button={button} isTopElement={true}
                                                      className={"flex-row-reverse"}/>
                                    </div>
                                </div>
                            </motion.div>
                        )}

                    </AnimatePresence>
                </div>
            </div>
        </GlobalPortal>
    );
};


export default InlineDialog;
